import { fetchData } from "../../Utils/fetchData";
import authToken from "../../Utils/authToken";
import { PhysicalGroupsData, HealthGroupsData, RehabilitationData, ChildCountData } from './form30SectorCharts-api';

export interface RFChartsData {
    physicalGroups: PhysicalGroupsData | null;
    healthGroups: HealthGroupsData | null;
    rehabilitation: RehabilitationData | null;
    childCount: ChildCountData | null;
}

export interface RFChartsResponse {
    success: boolean;
    data: RFChartsData;
}

/**
 * Получить средние данные графиков по РФ
 */
export const getRFAverageCharts = async (year: number): Promise<RFChartsResponse> => {
    const token = authToken();
    const response = await fetchData(`/form30/rf-average-charts?year=${year}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    }, 2);
    return response.json();
};
